import {createTheme} from "@mui/material/styles"

const spacing = 4

// Use this tool for named colors, e.g. vulcanSlate
// http://chir.ag/projects/name-that-color/
const colors = {
	indebtedPrimary: "#474CDE",
	green: "#388E3C",
	red: "#B00020",
	lightRed: "#F7E5E8",
	waterLeaf: "#A0E9E3",
	stratos: "#020452",

	// slate
	vulcanSlate: "#12161F",
	slate: "#1B222F",

	// greyscale
	boulderGrey: "#7D7D7D",
	lightGrey: "#EFEFEF",
	white: "#FFFFFF",

	black: "#000000",

	// chip colors
	chipPrimary: "#626392",
	chipPrimaryBackground: "rgba(98, 99, 146, 0.1)",
}

const palette = {
	primary: {main: colors.indebtedPrimary, contrastText: colors.white},
	secondary: {main: colors.slate, contrastText: colors.white},
	error: {main: colors.red, contrastText: colors.white},
}

const theme = createTheme({
	spacing,
	palette,
	components: {
		MuiButton: {
			defaultProps: {
				color: "primary",
				variant: "contained",
			},
		},
		MuiIconButton: {
			defaultProps: {
				color: "primary",
			},
		},
		MuiListItem: {
			defaultProps: {
				dense: true,
			},
		},
		MuiContainer: {
			styleOverrides: {
				root: {
					padding: spacing * 3,
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				head: {
					color: colors.boulderGrey,
					fontSize: "0.875rem",
				},
				body: {
					padding: spacing * 3,
				},
			},
		},
		MuiAccordionSummary: {
			styleOverrides: {
				root: {
					paddingLeft: spacing * 4,
					paddingRight: spacing * 4,
				},
			},
		},
	},
})

export {theme, colors}
